const validEmailErrorKey = 'errors.formFields.email';

// Regex from http://emailregex.com/
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmail = email => email.match(emailRegex);

const validEmail = () => (email) => {
  if (!email || !isValidEmail(email)) {
    return validEmailErrorKey;
  }
};

export default validEmail;
